export class IconWithText {
  constructor(public iconName: string, public key: string, public value: string) {
  }

}
